<template>
  <div class="doc-api-page">
    <div class="content-body">
      <div class="part-title">
        <span style="cursor: pointer" @click="goMessage">通知中心</span> / <span style="color: #666;">通知详情</span>
      </div>
      <div class="api-content-box">
        <div class="part-content">
          <div class="info-row">
            <div class="info-value" style="">
              <span style="font-size: 20px;font-weight: 900;color: #424456;">{{ title }}</span>
            </div>
          </div>
          <div class="info-row mt-sm">
            <div class="info-value">{{ created_at }}</div>
          </div>
          <div class="info-row mt-sm">
            <div v-html="content"></div>
          </div>


        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'messageDetail',
  data() {
    return {
      messageId: '',
      title: '',
      content: '',
      created_at: ''
    }
  },
  mounted() {
    this.messageId = this.$route.query.messageId
    this.getDetail()
  },

  methods: {


    // 获取详情
    getDetail() {

      // let detail ={'title':'测试发送邮件','content':'恭喜啊啊 嗷嗷啊','created_at':'2020-08-31 21:23:45'};
      //
      // this.title = detail.title;
      // this.content = detail.content;
      // this.created_at = detail.created_at;

      this.$axios.post("/ajax/message/info", {
        messageId: this.messageId
      }).then(res => {
        let detail = res.data.data;
        this.title = detail.title;
        this.content = detail.content;
        this.created_at = detail.created_at;
      });
    },
    goMessage() {
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="scss">

.doc-table-box {
  .el-table--mini,
  .el-table--small,
  .el-table__expand-icon {
    font-size: 13px;
  }

  .el-table__placeholder {
    margin-left: 1px;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: -14px;
      left: 50%;
      margin-left: -1px;
      width: 0;
      height: 20px;
      border-left: 1px dashed #ccc;
    }

    & + .el-table__placeholder {
      display: none;
    }
  }

  .el-table__expand-icon {
    margin-right: 1px !important;
  }
}

</style>
<style lang="scss" scoped>
.doc-api-page {
  width: 1170px;
  padding: 0 0 30px;
  margin: 0 auto;
}

.page-title {
  width: 100%;
  height: 28px;
  line-height: 28px;
  font-size: 18px;
  color: #212121;
  text-align: center;
  margin: 24px 0;
}

.content-body {
  position: relative;
  min-height: 500px;
  margin-top: 25px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);

  .part-title {
    width: 100%;
    line-height: 35px;
    color: #424456;
    font-size: 15px;
    padding-left: 46px;
    padding-bottom: 15px;
    padding-top: 20px;
    border-bottom: 1px solid #F2F2F2;
    font-weight: bold;
  }

  .part-title-s {
    width: 100%;
    line-height: 35px;
    color: #424456;
    font-size: 15px;
    padding-left: 2px;
    border-bottom: 1px solid #F2F2F2;
    font-weight: bold;
  }

  .notify-detail {
    position: absolute;
    left: 81px;
    top: 26px;
  }
}

.no-data-box {
  line-height: 30px;
  text-align: center;
  color: #666;
  font-size: 13px;
}

.api-list-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 237px;
  height: 100%;
  padding-top: 20px;
  background: #F4F5F6;
  box-sizing: border-box;

  .app-list-item {
    width: 100%;
    min-height: 40px;
    line-height: 18px;
    color: #212121;
    font-size: 14px;
    padding: 11px 20px 11px 20px;
    border-left: 3px solid transparent;
    box-sizing: border-box;
    cursor: pointer;

    &.active {
      color: #F16622;
      background: #fff;
      border-left-color: #F16622;
    }
  }
}

.api-content-box {
  width: 100%;
  padding: 22px 25px 23px 46px;
  box-sizing: border-box;

  .part-content {
    width: 100%;
    padding: 15px 3px 20px 5px;
    box-sizing: border-box;
  }

  .info-row {
    color: #212121;
    font-size: 14px;
    line-height: 24px;

    .info-label {
      display: inline-block;
      width: 90px;
      vertical-align: top;
    }

    .info-value {
      display: inline-block;
      vertical-align: top;
      color: #666;
    }

    .info-tag {
      display: inline-block;
      width: 60px;
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      background: #E4E6F4;
      border-radius: 2px;
      transform: scale(.88);
      transform-origin: left;
      margin-right: -5px;
    }

    .tag-position-top {
      position: relative;
      top: -1px;
    }
  }

  .json-box {
    padding: 15px;
    max-height: 520px;
    font-size: 13px;
    line-height: 15px;
    background: #F7F7F7;
    box-sizing: border-box;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message/detail.vue